import jTab from '../libs/jquery.j_tab_es';
import jTabac from '../libs/jquery.j_tabac_es';
import jModal from '../libs/j_modal_es';
import jSmoothScroll from '../libs/jquery.j_smoothScroll_es.js';
import jAccordion from '../libs/jquery.j_accordion_es';
const Init = () => {

    // console.log("全ページ共通で利用する機能はこちらに記述してください。");
    $(function () {
        const J_TAB = new jTab(
            '.j-tab',
            {
                fadeSpeed: 600
            }
        );

        if ($(".j-modal").length > 0) {

        
            const J_MODAL = new jModal(
                ".j-modal",
                {
                    width: 900,
                    modalSpeed: 400,
                    bgOpacity: 0.4,
                    innerBgColor: "#FFF",
                    innerBgPadding: 0,
                    closeCancel: false,
                    addClass: "wrap",
                    fixed: true
                }
            );
        }
        
        if ($(".j-modal_video").length > 0) {
            
            const J_MODAL_VIDEO = new jModal(
                ".j-modal_video",
                {
                    width: 900,
                    modalSpeed: 400,
                    bgOpacity: 0.4,
                    innerBgColor: "#FFF",
                    innerBgPadding: 0,
                    closeCancel: false,
                    addClass: "wrap",
                    fixed: true
                }
            );
        
            J_MODAL_VIDEO.OpenEnd = function () {
                $("#j-modal_video_wrap video").attr("id", "video");
        
                var video_elm = document.getElementById('video');
                video_elm.play();
        
            };
        }
        // videoの取得


        const J_TABAC = new jTabac(
            '.j-tabac',
            {
                slideSpeed: 200,
                fadeSpeed: 600
            }
        );

        const J_SCROLL = new jSmoothScroll(
            "a",
            {
                easing: "easeOutQuint",
                blank: true,
                customAnchor: "?anchor="
            }
        );

        const J_ACCORDION = new jAccordion(
            ".j-accordion",
            {
                toggleSpeed: 100
            }
        );

        $(".o-header_navbtn").on("click", function () {
            $(".o-header_navbtn").toggleClass("active");
            $(".o-header_navbox").toggleClass("active");

            if (!$(".o-header_navbox").hasClass("active")) {
                $(".o-header_nav > ul > li").removeClass("active");
            }
        });

        var hwidth = $("header").width();
        
        $(window).on("resize", function () { $(".o-header_nav > ul > li").removeClass("active"); hwidth = $("header").width(); });

        $(".o-header_nav > ul > li > a.o-header_nav_pc").on("mouseover", function () {
            
            $(".o-header_nav > ul > li").removeClass("active");
            $(this).parent("li").addClass("active");
        });

        $("#container").on("mouseover", function (e) { 
            if (hwidth > 768 && $(".o-header_navbox").hasClass("active")) {
                $(".o-header_nav > ul > li").removeClass("active");
                e.preventDefault();
                e.stopPropagation();
            }
        });

        $(".no_child").on("mouseover", function (e) {
            if (hwidth > 768 && $(".o-header_navbox").hasClass("active")) {
                $(".o-header_nav > ul > li").removeClass("active");
                e.stopPropagation();
            }
        });

        $(".o-header_nav > ul > li > a.o-header_nav_tb").on("click", function (e) {

            // $(".o-header_nav > ul > li").removeClass("active");
            $(".o-header_nav > ul > li > ul").height(0);
            if (!$(this).parent("li").hasClass("active")) {

                $(".o-header_nav > ul > li > ul").height(0);
                $(".o-header_nav > ul > li").removeClass("active");
                var tmpHeight = $(this).next("ul").find("li").height();
                tmpHeight = tmpHeight * ($(this).next("ul").find("li").length);
                $(this).next("ul").height(tmpHeight);
                $(this).parent("li").addClass("active");
            }
            else {
                $(".o-header_nav > ul > li > ul").height(0);
                $(".o-header_nav > ul > li").removeClass("active");
            }
            
            e.preventDefault();
        });

        if ($("#side").length > 0) {
            var mypath = location.pathname.replace("index.html", "");
            var pressesFlg = false;
            if (mypath.match("presses")) {
                $("#side a").eq(1).parent("li").addClass("active");
            }

            for (let i = 0; i < $("#side a").length; i++) {
                var tmppath = $("#side a").eq(i).attr("href");
                if (mypath.match(tmppath) && i > 0) {
                    $("#side a").eq(i).parent("li").addClass("active");
                    if (tmppath == "/about/history/group/") {
                        $("#side a").eq(i-1).parent("li").removeClass("active");
                    }
                }
            }
        }

    // 一元管理システム(メダルシステム)
        // $.getJSON("/g_common/json/profiles.json", function (data) {
        //     var subsidiary = [];
        //     var kaigai = [];
        //     var other = [];
        //     for (var i in data) {
        //         if (data[i][0] == "連結子会社") {
        //             subsidiary.push(data[i][1]);
        //         }
        //         if (data[i][0] == "海外子会社") {
        //             kaigai.push(data[i][1]);
        //         }
        //         if (data[i][0] == "その他") {
        //             other.push(data[i][1]);
        //         }
        //     }

        //     if (subsidiary.length != 0) {
        //         $("#subsidiary").append("●連結子会社<br/>");
        //         $.each(subsidiary, function (i, val) {
        //             $("#subsidiary").append(val + "<br/>");
        //         });
        //     }

        //     if (kaigai.length != 0) {
        //         $("#subsidiary").append("●海外子会社<br/>");
        //         $.each(kaigai, function (i, val) {
        //             $("#subsidiary").append(val + "<br/>");
        //         });
        //     }

        //     if (other.length != 0) {
        //         $("#subsidiary").append("●その他" + (other.length) + "社");
        //     }
        // })

        $.getJSON("/g_common/json/numbers.json", function(data) {
            for (var j in data) {
                if (data[j]['id'] == 4) { //創業年数
                    var str = getStr(data[j]);
                    $(".j-id_4").append(str);
                }

                if (data[j]['id'] == 5) { //入居率
                    var str = getStr(data[j]);
                    $(".j-id_5").append(str);
                }

                if (data[j]['id'] == 6) { //販売棟数
                    var str = getStr(data[j]);
                    $(".j-id_6").append(str);
                }

                if (data[j]['id'] == 8) { //管理棟数
                    var str = getStr(data[j]);
                    $(".j-id_8").append(str);
                    $(".j-id_8_value").append(data[j]['value']);
                    $(".j-id_8_unit").append(data[j]['unit']);
                }

                if (data[j]['id'] == 13) { //自社開発棟数
                    var str = getStr(data[j]);
                    $(".j-id_13").append(str);
                }

                if (data[j]['id'] == 14) { //自社開発棟数（年数単体ショートVer）
                    var str = getStr(data[j]);
                    $(".j-id_14").append(str);
                }

                if (data[j]['id'] == 16) { //自社施工実績
                    var str = getStr(data[j]);
                    $(".j-id_16").append(str);
                }
                if (data[j]['id'] == 18) { //管理棟数の備考
                    var str = getStr(data[j]);
                    $(".j-id_17").append(str);
                }
            }
        })
        .error(function(jqXHR, textStatus, errorThrown) {
            console.log("json読み込みエラー：" + textStatus);
        })

        function getStr(data) {
            var str = data['value'] + data['unit'];
            if (data['notice'] != "") {
                str += "（" + data['notice'] + "）";
            }
            return str;
        }
    });

}

export default Init;
